import doRequest from "../helpers";
import { getToken } from "../auth/tokenAuth";
import { getUserId } from "services/storage/general";
import { getTextByRangeMinutes } from "components/CustomTimePicker/utils";
import {
	getFullExtendedDateByTimestamp,
	getTodayWithoutHourInMillis,
} from "components/CustomDatePicker/utils/helpers";
import helpers, { toEventItem, getBodyToUpdateRequestStep2, toEventReportItem } from "./helpers";

//#region Evento CRUD
export const requestGetEventDrafts = async () => {
	const [result, err] = await doRequest(
		"/EventoCulturalBorrador",
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.evento;
};
export const requestGetEventListAdmin = async ({
	filterType,
	page,
	date,
	title,
	organizerId,
}) => {
	const [result, err] = await doRequest(
		"/LeerEventoVisualizacionMod",
		"POST",
		{
			tipoFiltro: filterType,
			fechaBuscar: date,
			pagina: page,
			titulo: title,
			idOrganizador: organizerId,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	const { listaVisualizacionEventos, paraSincronizar } = data.data;
	return {
		eventList: listaVisualizacionEventos?.map(toEventItem) || null,
		toSynchronize: paraSincronizar || false,
	};
};
export const requestGetEventListTeacher = async ({
	page,
	date,
	title,
	organizerId,
}) => {
	const [result, err] = await doRequest(
		"/LeerEventoVisualizacionDocenteMod",
		"POST",
		{
			codigoDocente: getUserId(),
			pagina: page,
			fechaBuscar: date,
			titulo: title,
			idOrganizador: organizerId,
		},
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.listaVisualizacionEventos.map(toEventItem);
};
export const requestGetQuantityEvents = async ({
	date,
	title,
	organizerId,
}) => {
	const [result, err] = await doRequest(
		"/CantidadListaEventoVisualizacionMod",
		"POST",
		{
			codigoUsuario: getUserId(),
			fechaBuscar: date,
			titulo: title,
			idOrganizador: organizerId,
		},
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	const {
		General: general,
		Pasados: past,
		Borrador: draft,
		Cancelados: canceled,
		NoProcesados: unprocessed,
	} = data.data.cantidadesEvento;
	return { 
		general, 
		past, 
		draft, 
		canceled, 
		unprocessed 
	};
};
export const requestGetEventById = async eventId => {
	const [result, err] = await doRequest(
		`/EventoCultural/Leer/${eventId}`,
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return helpers.parseToEventForm(data.data.evento);
};
//#region Reprogramación para varios Días
export const requestGetEventDaysByEventId = async (eventId, isAdmin) => {
	const [result, err] = await doRequest(
		`/EventoCultural/DiasEvento/${eventId}/${isAdmin}`,
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	const today = getTodayWithoutHourInMillis();
	return data.data.leerEvento?.map(
		({
			idEventoCulturalFecha: id,
			fecha,
			horaInicio,
			horaFin,
			programacion: { lugar, zoom },
			hoy: isToday,
			puedeTomarAsistencia: canTakeAttendance,
		}) => {
			const time = {
				value: {
					start: horaInicio,
					end: horaFin,
				},
				formatted: "",
			};
			time.formatted = getTextByRangeMinutes({ ...time.value }, "a");
			return {
				id,
				date: {
					value: fecha,
					formatted: getFullExtendedDateByTimestamp(fecha, today),
				},
				time: time,
				programming: {
					place: lugar && {
						campus: lugar.campus,
						address: lugar.direccion,
					},
					zoom,
				},
				canTakeAttendance,
				isToday,
				isPast: fecha < today,
			};
		}
	);
};
export const requestDeleteDateEventById = async id => {
	const [result, err] = await doRequest(
		"/EventoCultural/BorrarFecha",
		"POST",
		{
			idEventoCulturalFecha: id,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (data?.state !== 1) return false;
	return data.data.exito;
};
export const requestUpdateDateEventById = async ({
	id: idEventoCulturalFecha,
	date: fecha,
	time: { start: horaInicio, end: horaFin },
}) => {
	const body = {
		idEventoCulturalFecha,
		codigoUsuario: getUserId(),
		fecha,
		horaInicio,
		horaFin,
	};
	const [result, err] = await doRequest(
		"/Evento/EditarFechaHoraEvento",
		"POST",
		body,
		getToken()
	);
	if (err) return { success: false };
	const { data: payload } = result;
	if (payload?.state === 1) 
		return { success: true };
	const { data } = payload;
	return {
		success: data?.exito,
		message: data?.mensaje,
	};
};
// Lista de horarios con cruces
//#endregion
export const requestCreateEvent = async form => {
	const body = {
		codigoUsuario: getUserId(),
		...helpers.getBodyToAddOrUpdateRequestStep1(form),
	};

	const [result, err] = await doRequest(
		"/Evento/CargaManual/Crear",
		"POST",
		body,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.idEvento;
};
export const requestUpdateEventById = async (
	eventId,
	form,
	step,
	ignoreDurationFields
) => {
	let body = {
		codigoUsuario: getUserId(),
		idEvento: eventId,
	};
	if (step === "step1") {
		body = {
			...body,
			...helpers.getBodyToAddOrUpdateRequestStep1(
				form,
				ignoreDurationFields
			),
		};
	} else if (step === "step2") {
		body = {
			...body,
			...getBodyToUpdateRequestStep2(form),
		};
	}
	const [result, err] = await doRequest(
		"/Evento/CargaManual/Editar",
		"POST",
		body,
		getToken()
	);
	if (err) return { 
		success: false, 
		message: null,
		schedulesWithCrossings: null
	};
	const { data: payload } = result;
	if (payload?.state === 1) 
		return { 
			success: true, 
			message: null,
			schedulesWithCrossings: null
		};
	const { data } = payload;
	return {
		success: data?.exito,
		message: data?.mensaje,
		schedulesWithCrossings: data?.listaCruces?.map(({ fechaHora }) => fechaHora) || null
	};
};
export const requestDeleteEventById = async eventId => {
	const [result, err] = await doRequest(
		`/Evento/CargaManual/Cancelar`,
		"POST",
		{
			idEvento: eventId,
			codigoUsuario: getUserId(),
		},
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (![0, 1].includes(data?.state))
		return {
			message: null,
			success: false,
		};
	return {
		message: data.data.mensaje,
		success: data.data.exito,
	};
};
export const requestFinalizeEventDraft = async eventId => {
	const [result, err] = await doRequest(
		"/Evento/CargaManual/Finalizar",
		"POST",
		{
			idEvento: eventId,
		},
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (![0, 1].includes(data?.state)) return null;
	return data.data?.mensaje || null;
};
export const requestEventExists = async eventId => {
	if (!eventId) return false;
	const [result, err] = await doRequest(
		`/EventoCulturalExiste/${eventId}`,
		"GET",
		null,
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (data?.state !== 1) return false;
	return data.data.evento;
};
export const requestCanUpdateEventDuration = async eventId => {
	if (!eventId) return false;
	const [result, err] = await doRequest(
		`/Evento/DuracionPuedeEditarse/${eventId}`,
		"GET",
		null,
		getToken()
	);
	if (err) return false;
	const { data } = result;
	if (data?.state !== 1) return false;
	return data.data.puedeEditarse;
};
export const requestValidateFileForCreateEventMassiveLoading = async fileBase64 => {
	const [result, err] = await doRequest(
		"/EventoCargaMasiva/ValidarArchivo",
		"POST",
		{ archivoCargaMasiva: fileBase64 },
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (![0, 1].includes(data?.state)) return null;
	return {
		rowCountFile: data.data.cantidadFilas,
		errorStack: data.data.pilaErrores.map(({ fila, mensaje }) => {
			return { row: fila, message: mensaje };
		}),
	};
};
export const requestCreateEventMassiveLoading = async fileBase64 => {
	const [result, err] = await doRequest(
		"/EventoCargaMasiva/Crear",
		"POST",
		{
			codigoUsuario: getUserId(),
			archivoCargaMasiva: fileBase64,
		},
		getToken()
	);
	if (err) return null;
	const { data } = result.data;
	if (data.exito)
		return {
			success: true,
		};
	const { fila, mensaje } = data;
	if (fila || mensaje)
		return {
			row: fila || 0,
			message: mensaje || null,
		};
	const { exito, cantERROR, cantOK, pilaErrores } = data;
	return {
		success: exito,
		quantities: {
			ok: cantOK || 0,
			error: cantERROR || 0,
		},
		errorStack:
			pilaErrores?.map(({ fila, codDocente, mensaje }) => ({
				row: fila,
				teacherId: codDocente,
				message: mensaje,
			})) || [],
	};
};
export const requestSyncUnprocessedEvent = async () => {
	const [result, err] = await doRequest(
		"/EventoCargaMasiva/Sincronizar",
		"POST",
		{ codigoUsuario: getUserId() },
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state === 0)
		return {
			message: data.data.mensaje,
		};
	if (data?.state !== 1) return null;
	const { Procesados, NoProcesados, Pendientes } = data.data;
	return {
		processed: Procesados,
		unprocessed: NoProcesados,
		pending: Pendientes,
	};
};
//#endregion
//#region Usuario
export const requestUserHasEvents = async (userCode, isTeacherUser) => {
	const [result, err] = await doRequest(
		"/UsuarioPorEventoCultural",
		"POST",
		[userCode, isTeacherUser],
		getToken()
	);
	if (err) return null;
	const { data } = result;
	if (data?.state !== 1) return null;
	return data.data.existe;
};
//#endregion
//#region Waitlist
export const requestGetWaitlistReport = async() => {
	const [result, err] = await doRequest(
		`/Evento/ReporteListaEspera/0`,//0 por default para que considere el periodo actual
		"GET",
		null,
		getToken()
	);
	if (err) return null;
	const { data } = result;
	const { archivoBase64 } = data.data;
	return archivoBase64;
};
//#endregion
